<template>
	<v-dialog
		content-class="app-confirm-dialog"
		persistent
		:value="showModal"
		:width="width"
	>
		<v-card class="app-confirm-card">
			<div class="app-confirm-body">
				<span
					class="app-confirm-icon"
					:style="{ backgroundColor: tokens.tint, color: tokens.accent }"
				>
					<v-icon>{{ icon }}</v-icon>
				</span>
				<div class="app-confirm-copy">
					<small>{{ eyebrow }}</small>
					<h3>{{ title }}</h3>
					<p>{{ text }}</p>
					<span v-if="hint" class="app-confirm-hint">
						<v-icon>info_outline</v-icon>{{ hint }}
					</span>
				</div>
			</div>
			<div class="app-confirm-actions">
				<button
					type="button"
					class="app-confirm-btn app-confirm-btn-ghost"
					:disabled="loading"
					@click="$emit('cancel')"
				>
					{{ cancelText }}
				</button>
				<button
					type="button"
					class="app-confirm-btn app-confirm-btn-solid"
					:disabled="loading"
					:style="{ backgroundColor: tokens.accent }"
					@click="$emit('confirm')"
				>
					<v-progress-circular
						v-if="loading"
						class="mr-2"
						indeterminate
						size="14"
						width="2"
					/>
					{{ loading ? loadingText : confirmationText }}
				</button>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
const TONES = {
	danger: { accent: '#d64545', icon: 'delete_outline', tint: '#fdecec' },
	info: { accent: '#176fc1', icon: 'help_outline', tint: '#eaf2fb' },
	warning: { accent: '#c8871a', icon: 'warning', tint: '#fdf1dc' },
};

function tokens() {
	return TONES[this.tone] || TONES.danger;
}

function icon() {
	return this.iconName || this.tokens.icon;
}

export default {
	name: 'app-confirmation-modal',
	computed: {
		icon,
		tokens,
	},
	props: {
		cancelText: {
			type: String,
			default: 'Cancelar',
		},
		confirmationText: {
			type: String,
			default: 'Eliminar',
		},
		eyebrow: {
			type: String,
			default: 'CONFIRMACIÓN REQUERIDA',
		},
		hint: {
			type: String,
			default: '',
		},
		iconName: {
			type: String,
			default: '',
		},
		loading: {
			default: false,
			type: Boolean,
		},
		loadingText: {
			type: String,
			default: 'Procesando…',
		},
		showModal: {
			type: Boolean,
			default: false,
		},
		text: {
			type: String,
			default: 'Está seguro que desea eliminar este registro?',
		},
		title: {
			type: String,
			default: 'Confirma la acción',
		},
		tone: {
			type: String,
			default: 'danger',
		},
		width: {
			type: Number,
			default: 460,
		},
	},
};
</script>

<style lang="scss">
.app-confirm-dialog {
	border-radius: 16px !important;
	box-shadow: 0 24px 60px rgba(19, 38, 57, .28) !important;
}
</style>

<style lang="scss" scoped>
.app-confirm-card {
	border-radius: 16px !important;
	box-shadow: none !important;
	overflow: hidden;
	padding: 0;
}

.app-confirm-body {
	display: flex;
	gap: 14px;
	padding: 22px 22px 18px;
}

.app-confirm-icon {
	align-items: center;
	border-radius: 13px;
	display: flex;
	flex: 0 0 auto;
	height: 46px;
	justify-content: center;
	width: 46px;

	.icon { color: inherit; font-size: 23px; }
}

.app-confirm-copy {
	min-width: 0;

	small {
		color: #8497a8;
		display: block;
		font-size: 9px;
		font-weight: 700;
		letter-spacing: .12em;
	}

	h3 {
		color: #263f56;
		font-family: map-get($fonts, open-semibold);
		font-size: 16px;
		font-weight: 600;
		line-height: 1.3;
		margin: 2px 0 0;
	}

	p {
		color: #6b7c8d;
		font-size: 13px;
		line-height: 1.45;
		margin: 6px 0 0;
	}
}

.app-confirm-hint {
	align-items: center;
	color: #8495a5;
	display: flex;
	font-size: 11px;
	gap: 5px;
	margin-top: 9px;

	.icon { color: #b4bfca; font-size: 14px; }
}

.app-confirm-actions {
	background: #f7f9fc;
	border-top: 1px solid #e9eff5;
	display: flex;
	gap: 9px;
	justify-content: flex-end;
	padding: 14px 22px;
}

.app-confirm-btn {
	align-items: center;
	border: 1px solid transparent;
	border-radius: 9px;
	cursor: pointer;
	display: inline-flex;
	font-size: 12px;
	font-weight: 700;
	height: 38px;
	justify-content: center;
	letter-spacing: .02em;
	min-width: 108px;
	outline: none;
	padding: 0 16px;
	transition: background .15s ease, box-shadow .15s ease;

	&:disabled { cursor: default; opacity: .65; }
}

.app-confirm-btn-ghost {
	background: #fff;
	border-color: #d4dee7;
	color: #53697d;

	&:hover:not(:disabled) { background: #f1f5f9; }
}

.app-confirm-btn-solid {
	background: #d64545;
	color: #fff;

	&:hover:not(:disabled) { filter: brightness(.93); }
}

@media (max-width: 560px) {
	.app-confirm-body { padding: 18px 16px 14px; }
	.app-confirm-actions { flex-direction: column-reverse; padding: 13px 16px; }
	.app-confirm-btn { width: 100%; }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/app-confirmation-modal.vue